import type { TFunction } from 'i18next';
import { Switch } from '@/shared/components/ui/switch';
import { MemberRole, type Member } from '../../types';

interface StatusCellProps {
  member: Member;
  onChange: (activate: boolean) => void;
  isLoading?: boolean;
  t: TFunction;
}

export function StatusCell({ member, onChange, isLoading }: StatusCellProps) {
  const isEditable = member.role !== MemberRole.Owner && !member.isCurrentUser;

  return (
    <Switch
      checked={member.isActive}
      onCheckedChange={onChange}
      disabled={!isEditable || isLoading}
      data-testid={`members-status-switch-${member.id}`}
    />
  );
}
